import Modal from "@mui/material/Modal";
import {kButtonStyles, kModalStyles} from "../../constants/styles";
import {kSystemIcons} from "../../constants/icons";
import {SystemPrimaryCustomButton, SystemSecondaryCustomButton} from "../buttons/SystemCustomButton";
import SystemScreenInfoHeader from "../headers/SystemScreenInfoHeader";

export default function SystemLeaveExerciserDialog({ open,
                                                 handleClose,
                                                 leave }) {
    // Used in MetaFlashScreen to ask confirmation
    // about leaving current flash

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.neoDialogStyle}>
                {/** HEADER */}
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.exit}
                                        title={"Quitter l'exercice ?"} />
                {/** CONTENT */}
                <div className={"w-full flex flex-col justify-start items-start px-[24px] pb-[24px] mt-[16px]"}>
                    <span className={"font-normal text-[16px] text-greyLight11"}>
                        {"Tu perdras toute ta progression et tu ne pourras pas consulter la correction des questions auxquelles tu as déjà répondu."}
                    </span>
                    <div className={"mt-[16px] w-full flex space-x-[16px]"}>
                        <SystemSecondaryCustomButton
                            label={"Annuler"}
                            isDisabled={false}
                            isLoading={false}
                            isFullWidth={true}
                            sizeStyle={kButtonStyles.mediumButtonStyle}
                            extraClass={"w-full"}
                            onButtonClick={handleClose} />
                        <SystemPrimaryCustomButton
                            label={"Quitter"}
                            isDisabled={false}
                            isLoading={false}
                            isFullWidth={true}
                            sizeStyle={kButtonStyles.mediumButtonStyle}
                            extraClass={"w-full"}
                            onButtonClick={leave} />
                    </div>
                </div>
            </div>
        </Modal>
    )
}